import React, { useState } from 'react';
import { IonList, IonItem, IonIcon, IonLabel } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import './NFCValidator.css';
import { platformAndroid } from '../../utils/platform';

declare global {
  interface Window {
    MOBILEvarioSdk?: {
      isNfcEnabled?: () => boolean;
    };
  }
}

type NFCValidatorProps = object;

const NFCValidator: React.FC<NFCValidatorProps> = () => {
  const [t] = useTranslation('global');
  const [isAndroidPlatform] = useState<boolean>(platformAndroid() !== null);
  const [nfcAvailable] = useState<boolean>(
    isAndroidPlatform && window.MOBILEvarioSdk?.isNfcEnabled?.() === true,
  );

  if (!isAndroidPlatform || !nfcAvailable || process.env.REACT_APP_SHOW_NFC_BUTTON !== 'true') return null;

  return (
    <IonList className="pt-2">
      <IonItem
        lines="none"
        className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-option nfc-item"
        color="primary"
      >
        <IonIcon
          slot="start"
          src="assets/icon/NFC.svg"
          className="nfc-validator-icon"
        ></IonIcon>
        <IonLabel>
          <p className="nfc-item-text">{t('nfc.text')}</p>
        </IonLabel>
      </IonItem>
    </IonList>
  );
};

export default NFCValidator;
